export function canSendTestWhatsapp(input: {
  commsEnabled: boolean;
  systemConfigured: boolean;
  connected: boolean;
}): boolean {
  return input.commsEnabled && input.systemConfigured && input.connected;
}
